const fullNameMask = value => {
  return value && value.trim().split(' ').length > 1 || false;
};

export default fullNameMask;